import { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import VZHeaderlogo from "./../assets/Verizon_RGB.svg";
import { Spin } from "antd";

// Allow redirect only for viewshipment and devices/:id/*
const isAllowedRedirect = (pathname) => {
  const shipmentRegex = /^\/viewshipment(\/[^/]+)?$/; // Matches /viewshipment or /viewshipment/:id
  const assetRegex = /^\/assets(\/[^/]+)?$/; // Matches /viewasset or /viewasset/:id
  const deviceRegex = /^\/devices\/[^/]+\/(map|dashboard|explorer)$/;
  return shipmentRegex.test(pathname) || assetRegex.test(pathname) || deviceRegex.test(pathname);
};

const ProtectedRoute = () => {
  const [isLoading, setIsLoading] = useState(true);
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();

  if (!isLoading && (!user || !user.bearerToken)) {
    const redirectPath = isAllowedRedirect(location.pathname)
      ? location.pathname
      : "/insights";

    return <Navigate to={"/login"} replace state={{ from: redirectPath }} />;
  } else if (isLoading) {
    // Simulate loading delay
    setTimeout(() => setIsLoading(false), 500);
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 vw-100">
        <div className="d-flex flex-column justify-content-center align-items-center">
          <img src={VZHeaderlogo} alt="Loading..." className="w-50 h-50"/>
          <Spin tip="Loading" size="small" className="ml-5"></Spin>
        </div>
      </div>
    ); // or a loading spinner
  }

  return <Outlet />;
};

export default ProtectedRoute;
